import type { AssetsListTableRowActionsProps } from "./assets-list-table-row-actions.type";

import AssetEdit from "@/features/Assets/AssetEdit";
import { AssetDuplicateButton } from "@/modules/asset/asset-duplicate";
import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelEditButtonLegacy from "@/modules/model-edit-button-legacy";
import ModelViewButton from "@/modules/model-view-button";

const AssetsListTableRowActions = ({
  asset,
}: AssetsListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="asset"
        item={asset}
        onClick={closePopover}
      />
      <ModelEditButtonLegacy
        type="text"
        modelKey="asset"
        item={asset}
        component={<AssetEdit assetId={asset.id} />}
        onClick={closePopover}
      />
      <AssetDuplicateButton type="text" asset={asset} onClick={closePopover} />
      <ModelDeleteButton
        type="text"
        modelKey="asset"
        item={asset}
        invalidateKeys={[
          ["assets", "coordinates"],
          ["locations", "coordinates"],
        ]}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};

export default AssetsListTableRowActions;
